import antdVars from '../antd-vars';
import spacing from './spacing';

const heightBase = 40;
const borderWidth = 1;

const antdGeneralVariables = {
  classnamePrefix: antdVars['ant-prefix'],
  iconfontCssPrefix: 'anticon',
  borderRadiusBase: 4,
  borderWidth: borderWidth,
  heightSm: 32,
  heightBase: heightBase,
  iconSize: 24,
  // TODO (FEINF-1545): Update with icon overhaul to 16px
  iconFontSize: 13,
  iconFontSizeNew: 16,
  buttonHeight: heightBase,
  // Height available within button (for label and icon). Same for middle and small buttons.
  buttonInnerHeight: heightBase - spacing.sm * 2 - borderWidth * 2,
};

export default antdGeneralVariables;
